<template>
	<div class="update-account" @click="$sidebar.displaySidebar(false)">			
		<div class="row ">
            <div class="col-xl-8 mb-5 mb-xl-0">
                <div class="card shadow">
                   <div class="card-body">
                          <h4 class="mb-3">ユーザー編集</h4>
                          <div>
                              <transition name="slide-fade">
                              <div class="alert alert-success" v-if="info" >{{ info }}</div>
                            </transition>

                            <div class="form-group " v-bind:class="{  'text-danger has-error': errors.roles }">
                
                            <label for="site">ロール<span class="badge badge-required">必須</span></label>
                        <div class="input-group" >
                          <select  class="" v-model="roleSelected" >
                            <option  value="">--</option>

                            <option v-for="(n,key) in allRoles" :key="key" :value="n.id">{{ n.name }}</option>
                          </select>
                        </div>
                          <p v-for="(error,key) in errors.roles" :key="key" class="error-text" >{{error}}</p>
                        
                        </div>

                              <div class="form-group" v-bind:class="{  'text-danger has-error': errors.name }">
                                  <label for="name">名前<span class="badge badge-required">必須</span></label>
                                  <input type="text" v-model="name" class="form-control" name="name" id="name" />
                                    <p v-for="(error,key) in errors.name" :key="key" class="error-text" >{{error}}</p>
                              </div>
							             

                              <div class="form-group">
                                  <label for="email">メールアドレス<span class="badge badge-required">必須</span></label>
                                  <input type="email" v-model="email" readonly class="form-control" name="email" id="email" />
                                   
                              </div>

                               <div class="form-group" v-bind:class="{  'text-danger has-error': errors.personal_company_name }">
                                  <label for="personal_company_name">会社名<span class="badge badge-option">任意</span></label>
                                  <input type="text" v-model="personal_company_name" class="form-control" name="personal_company_name" id="personal_company_name" />
                                    <p v-for="(error,key) in errors.personal_company_name" :key="key" class="error-text" >{{error}}</p>
                              </div>

<!--
							                <div class="form-group" v-bind:class="{  'text-danger has-error': errors.zipcode }">
                                  <label for="zipcode">郵便番号<span class="badge badge-required">必須</span></label>
                                  <input type="text" v-model="zipcode" class="form-control" name="zipcode" id="zipcode" />
                                    <p v-for="(error,key) in errors.zip_code" :key="key" class="error-text" >{{error}}</p>
                              </div>
							                <div class="form-group" v-bind:class="{  'text-danger has-error': errors.state }">
                                  <label for="state">東道府県<span class="badge badge-required">必須</span></label>
                                  <input type="text" v-model="state" class="form-control" name="state" id="state" />
                                    <p v-for="(error,key) in errors.state" :key="key" class="error-text" >{{error}}</p>
                              </div>

							                <div class="form-group" v-bind:class="{  'text-danger has-error': errors.city }">
                                  <label for="city">市<span class="badge badge-required">必須</span></label>
                                  <input type="text" v-model="city" class="form-control" name="city" id="city" />
                                    <p v-for="(error,key) in errors.city" :key="key" class="error-text" >{{error}}</p>
                              </div>
 -->

							                <div class="form-group" v-bind:class="{  'text-danger has-error': errors.address1 }">
                                  <label for="address1">住所<span class="badge badge-option">任意</span></label>
                                  <input type="text" v-model="address1" class="form-control" name="address1" id="address1" />
                                    <p v-for="(error,key) in errors.address_1" :key="key" class="error-text" >{{error}}</p>
                              </div>

                             <div class="form-group" v-bind:class="{  'text-danger has-error': errors.phone }">
                                  <label for="phone">電話番号<span class="badge badge-option">任意</span></label>
                                  <input type="text" v-model="phone" class="form-control" name="phone" id="phone"/>
                                    <p v-for="(error,key) in errors.phone" :key="key" class="error-text" >{{error}}</p>
                              </div>

							  <div class="form-group" v-bind:class="{  'text-danger has-error': errors.dept }">
                                  <label for="dept">部署<span class="badge badge-option">任意</span></label>
                                  <input type="text" v-model="dept" class="form-control" name="dept" id="dept" />
                                    <p v-for="(error,key) in errors.dept" :key="key" class="error-text" >{{error}}</p>
                              </div>

							   <div class="form-group" v-bind:class="{  'text-danger has-error': errors.designation }">
                                  <label for="designation">役職<span class="badge badge-option">任意</span></label>
                                  <input type="text" v-model="designation" class="form-control" name="designation" id="designation" />
                                    <p v-for="(error,key) in errors.designation" :key="key" class="error-text" >{{error}}</p>
                 </div>

                <div class="form-group site-selection-area" v-bind:class="{'text-danger has-error': errors.site }">
                  <label for="site">管理サイト<span class="badge badge-required">必須</span></label>
                  <div id="site-selection-wrapper">
                    
                  <div class="input-group" :id="`selection-group${index+1}`" v-for="(v,index) in selectedSitesInfo" :key="index">
                    <select  class="" name="permittedSite[]"  id="select1" @change="onSiteSelect">
                      <option  value="">--</option>
                      <option v-for="site in siteData" :key="site.id" :value="site.id" :selected="v.site_id == site.id">{{ site.site_name_jp }}</option>
                    </select>
                    <div class="selected-option"><span class="opt-val">{{ getDomainName(v.site_id) }}</span></div>
                    <div class="delete-site-selection" id="">
                      <button @click="deleteSelection" id="deleteBtn1"></button> 
                    </div> 
                  </div>
                </div>
                  <p v-for="(error,key) in errors.sites" :key="key" class="error-text" >{{error}}</p>
                </div>
                <div class="add-site-selection" id="siteSelectionBtn">
                  <hr/>
                  <button @click="cloneSiteSelection"></button> 
                </div>  

<!--
                <div class="form-group">
                    <label >ロール<span class="badge badge-required">必須</span></label>
                    <ul  class="checkbox-container">
                        <li class="form-check" v-for="(n,key) in allRoles" :key="key">
                          <input type="checkbox" v-model="roleSelected" :value="n.id" class="form-check-input" :id="n.id">
                          <label class="form-check-label" :for="n.id">{{ n.name }}</label>
                        </li>
                    </ul>
                    <p v-for="(error,key) in errors.roles" :key="key" class="error-text" >{{error}}</p>
                </div>	
                -->						  
<!--
							   会社名　アドレス　名前　部署　役職　電話番号　住所の変更ができる
							  "created_at":"2021-05-18T11:40:16.000000Z","updated_at":"2021-05-18T11:42:23.000000Z","company_id":1,"username":"","designation":"","is_active":1,"sys_admin":0,"name":"","dept":"","phone":""}

-->
							    <div class="btn-wrap form-group text-center">
									  <a class="btn btn-primary btn-white" :href="'/users/' + siteId + '/list'">一覧に戻る</a>
                    <button  class="btn btn-primary" @click="save"  :disabled="loading" >更新</button>
									  <!-- <a class="btn btn-primary" :href="'/users/' + userDetails.id + '/edit' ">更新する</a> -->
                  </div>
                  </div>
					          </div>
                </div>
            </div>
			
		</div>
	</div>
</template>

<script>
 // import { Select, Option } from 'element-ui'
// import { ElSelect, ElOption } from "element-plus";
import { setupCache } from 'axios-cache-adapter';
import assert from 'assert'
export default {
  props: ['roleData', 'selectedUserData', 'userRole', 'siteList', 'usersSite'],
  components: {
    
  //  [Select.name]: Select,
  //  [Option.name]: Option,
    },
	data() {
		return {
			// Our data object that holds the Laravel paginator data
      allRoles:{},
      siteData:{},
      errors: {},
      user_id:null,
      designation: '',
      dept: '',
      phone: '',
      address1: '',
      email:'',
      country: "JP",
      personal_company_name: '',
      name:'',
			siteId:0,
      loading: false,
      roleSelected: '',
      info:null,
      siteCnt:0,
      loopCnt:0,
      siteSelectionIndex:1,
      selectedSites:[],
      selectedSitesInfo:{},
      defaultSiteSelectionBlock:null
		}
	},

	mounted() {
		// Fetch initial results
		this.siteId = window.PushL.site_id;
    this.allRoles = JSON.parse(this.roleData);
    this.siteData = JSON.parse(this.siteList);
    const userData = JSON.parse(this.selectedUserData);
    this.user_id = userData.id;
    this.designation = userData.designation;
    this.dept = userData.dept;
    this.phone = userData.phone;
    this.address1 = userData.address_1;
    this.email = userData.email;
    this.personal_company_name = userData.personal_company_name;

    this.country = userData.country ? userData.country : "JP";
   
    this.name = userData.name;
    let tmp = JSON.parse(this.userRole);
    this.roleSelected = tmp[0];
    this.siteCnt = (this.siteData).length;
    this.selectedSitesInfo = JSON.parse(this.usersSite);
    console.log(this.siteData);
    console.log(this.selectedSitesInfo);

    for (let i=0; i<this.selectedSitesInfo.length; i++) {
      this.selectedSites.push(parseInt(this.selectedSitesInfo[i].site_id))
      this.loopCnt++
    }

    console.log(this.siteCnt)
    console.log(this.loopCnt)

    if(this.loopCnt == this.siteCnt) {
      document.getElementById('siteSelectionBtn').style.display='none';
    }


	},

compute:{
},
watch: {
  /*'zipcode': function(val, oldVal){
      if(/^\d*$/.test(val) == false || val.length > 7) {
        this.errors.zipcode = ["7桁数字を入力してください"];
        return;
      }
      this.errors.zipcode = null;
      if (7 > val.length) {
        return;
      }
      this.getAddressFromPostCode();
  }*/
},
	methods: {
    validateEmail() {
      /*if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(this.email)) {
          this.msg['email'] = 'Please enter a valid email address';
      } else {
          this.msg['email'] = '';
      }*/
    },
    getDomainName(site_id) {
      for(let i=0; i< this.siteData.length; i++) {
          if(this.siteData[i].id == site_id) {
            return this.siteData[i].site_domain;
          }
      }
    },
    onSiteSelect(event) {
      const target = event.target;
      const val = parseInt(target.value);
      //this.selectedSite.push(val);
      let siteDomain = "";
      for(let i=0; i< this.siteData.length; i++) {
          if(this.siteData[i].id == val) {
            siteDomain = this.siteData[i].site_domain
          }
      }
      jQuery(target).next().find(".opt-val").text(siteDomain);

      let index = (this.selectedSites).indexOf(val);
      if (index == -1) {
        (this.selectedSites).push(val);
      }

      /*
      let x = document.getElementsByName('permittedSite[]');
      var len = x.length;

      for (var i=0; i<len; i++) {
        let v = parseInt(x[i].value);
        let index = (this.selectedSites).indexOf(v);
        if (index == -1) {
          (this.selectedSites).push(v);
        }
      }
      */
    },

cloneSiteSelection () {
    //site-selection-wrapper

    this.loopCnt++;
    this.siteSelectionIndex++;
    /*let newGroup = jQuery("#selection-group1").clone(true,true);
    newGroup.attr("id", `selection-group${this.siteSelectionIndex}`);
    newGroup.appendTo("#site-selection-wrapper");
    */
    
    const parent = document.getElementById('site-selection-wrapper');
    let node = document.createElement("div")
    node.id= `selection-group${this.siteSelectionIndex}`;
    node.classList.add("input-group");
   
    const onChange = () => console.log('clicked')
    const select = document.getElementById('select1');
    select.onChange = onChange
    const fn = this.onSiteSelect;
    const clone = select.cloneNode(true);
    clone.id = `select${this.siteSelectionIndex}`;
    clone.addEventListener('change', fn);
    node.appendChild(clone);

    const selectedOptionWrapper = document.createElement('div');
    selectedOptionWrapper.classList.add("selected-option");
    console.log(selectedOptionWrapper);
    let temp = document.createElement("span");
    temp.classList.add("opt-val");
    selectedOptionWrapper.appendChild(temp);
    node.appendChild(selectedOptionWrapper);

    const deleteBtn = document.getElementById('deleteBtn1');
    const onClick = () => console.log('clicked');
    deleteBtn.onClick = onClick
    const fn3 = this.deleteSelection;
    const deleteBtnWrapper =  document.createElement('div');
    deleteBtnWrapper.classList.add('delete-site-selection');
    console.log(deleteBtnWrapper)
    const clone3 = deleteBtn.cloneNode(true);
    clone3.id = `deleteBtn${this.siteSelectionIndex}`;
    clone3.addEventListener('click', fn3);
    deleteBtnWrapper.appendChild(clone3);
    node.appendChild(deleteBtnWrapper);
    parent.appendChild(node);

    
    if(this.loopCnt >= this.siteCnt) {
      document.getElementById('siteSelectionBtn').style.display='none';
    }
},

    deleteSelection (event) {
     
      let target = jQuery(event.target).parents(".input-group");
      const value = parseInt(target.find("select").val());

      console.log(value)
      const index = (this.selectedSites).indexOf(value);
      console.log(index)
      if (index !== -1) {
        (this.selectedSites).splice(index, 1);
      }

      jQuery(target).find(".opt-val").text("");
      jQuery(target).find('select').val("");
      if(target[0].id == "selection-group1") {
        console.log("default");
      } else {
        target.remove();
        this.loopCnt--;
        if(this.loopCnt < this.siteCnt) {
          //jQuery('#siteSelectionBtn').show();
          document.getElementById('siteSelectionBtn').style.display='';
        }
      }
      
    },

    getAddressFromPostCode() {

     return;
      
      // Create `axios-cache-adapter` instance
      const cache = setupCache({
        maxAge: 15 * 60 * 1000,
        debug: true,
        exclude: {
          query: false,
        }
      })

      // Create `axios` instance passing the newly created `cache.adapter`
      const api = axios.create({
        adapter: cache.adapter
      })
      api.get(`/zipcode/${this.zipcode}`)
      .then(async (response) => {
        console.log(response.data.code);
        // Interacting with the store, see `localForage` API.
        const length = await cache.store.length()
        console.log('Cache store length:', length)
        if(response.data.code == 200) {
          const address = response.data.data;
          this.address1 =  address.town
          this.city =  address.city;
          this.state =  address.pref;
        }
      });
     
    },
		// Our method to GET results from a Laravel endpoint
		 save() {
      this.loading = true;
      this.isSend = 0;
      this.errors = {};
      axios.put(`/users/${this.user_id}`, {
        "_method": "post",
        name : this.name,
        //email : this.email,
        dept : this.dept,
        designation: this.designation,
        personal_company_name: this.personal_company_name,
        //zip_code : this.zipcode,
        //state : this.state,
        //city : this.city,
        address_1 : this.address1,
        phone : this.phone,
        country : this.country,
        roles : this.roleSelected,
        sites: this.selectedSites,
      	//reservation_at: moment(this.reservationDate).format('YYYY-MM-DD') + " "+this.reservationHour+":"+this.reservationMinute
      }).then(response => {
        this.loading = false;
        this.$toast(response.data.info, {
          toastClassName: "toaster"
        })
      }).catch(error => {
        console.log(error)
        if (error.response.status === 422) {
          this.errors = error.response.data.errors || {};
           this.loading = false;
           //this.info = error.response.data.info
        } else if (error.response.status === 419) {
          alert("ページセッション切りましたので、更新できませんでした。ページをリロードしてください")
        }
      });
    },
	}

}
</script>

<style >

.update-account .form-group select {
  padding: 1rem;
  min-width: 280px;
  margin-bottom:10px;
}

.update-account .add-site-selection {
  position: relative;
  text-align: center;
  max-width: 590px;
}
.update-account .delete-site-selection button,
.update-account .add-site-selection button {
    background-image: url('/img/icons/add-filled.svg');
    background-size: cover;
    width: 32px;
    height: 32px;
    background-color: transparent;
    border: none;
    position:absolute;
    top:-15px;
    margin-left: -16px;
}
.update-account .delete-site-selection button {
  background-image: url('/img/icons/delete-filled.svg');
  /* height 32px/2 + margin 10px/2 = 21px */
  top: calc(50% - 21px);
  right: -40px;
}

.update-account .input-group {
  max-width: 600px;
}
</style>